import React, { useContext, useEffect } from 'react';
import { useParams } from 'umi';
import { PR_WORKSPACE_PAGE_CONFIG } from './pageConfig';
import { PAGE_CONFIG_API } from '@home/_config/constant';
import CommonPageRender from '@home/components/CommonPageRender';
import type { IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';
import { ThemeContext } from '@home/wrappers/common';
import { IData, IStudioParams } from '../type';
import './index.scss';

interface IHomeProps extends IData {
  homeReqParams?: string;
  prHubGameCode?: string;
}

const PR = (props: IHomeProps) => {
  const { studioData, homeReqParams, prHubGameCode } = props || {};
  const { themeValue } = useContext(ThemeContext);
  const { studioId } = useParams() as IStudioParams;
  const isCasual = studioId === 'casual';
  const reqParams = homeReqParams || '/pr';
  const pageConfigInit = PR_WORKSPACE_PAGE_CONFIG as unknown as IPageConfigType;

  useEffect(() => {
    if (isCasual) return;
    const element = document.querySelector('.dbh-studio-context');
    if (element) {
      (element as HTMLElement).classList?.add('dbh-studio-home-bg');
    }
    return () => {
      if (element) {
        (element as HTMLElement).classList.remove('dbh-studio-home-bg');
      }
    };
  }, [themeValue, isCasual]);


  return (
    <CommonPageRender
      key={`${studioId}-${reqParams}-${prHubGameCode || ''}`}
      className="dbh-pr-workspace-page"
      reqParams={reqParams}
      frameType='studio'
      pageConfigInit={pageConfigInit}
      api={PAGE_CONFIG_API}
      studioData={studioData}
      prHubGameCode={prHubGameCode}
    />
  );
};

export default PR;
